export const GRAB_ITEM = 'GRAB_ITEM';
export const DROP_ITEM = 'DROP_ITEM';
export const PICKUP_ITEM = 'PICKUP_ITEM';
export const ITEM_MOVING = 'ITEM_MOVING';

export const TRASH_CAN_HOVER = 'TRASH_CAN_HOVER';
export const SCENE_REDRAWN = 'SCENE_REDRAWN';

export const SHOW_CONF = 'SHOW_CONF';
export const SHOW_POPUP_ERROR = 'SHOW_POPUP_ERROR';
export const SHOW_POPUP_INTRO = 'SHOW_POPUP_INTRO';
export const SHOW_POPUP_INFO = 'SHOW_POPUP_INFO';
export const DISMISS_POPUP = 'DISMISS_POPUP';

export const IFRAME_RESIZED = 'IFRAME_RESIZED';

export const CONF_MENU_CHANGE = 'CONF_MENU_CHANGE';

export const SCREENSAVER_STARTED = 'SCREENSAVER_STARTED';

export const WALL_RESIZED = 'WALL_RESIZED';

export default {
  DISMISS_POPUP,
  GRAB_ITEM,
  DROP_ITEM,
  PICKUP_ITEM,
  ITEM_MOVING,
  TRASH_CAN_HOVER,
  SCENE_REDRAWN,
  SHOW_CONF,
  SHOW_POPUP_ERROR,
  SHOW_POPUP_INTRO,
  SHOW_POPUP_INFO,
  IFRAME_RESIZED,
  SCREENSAVER_STARTED,
  WALL_RESIZED,
};
